import './style/custom.css';
import './style/output.css';
import './style/style.2.bundle.rtl.css';
import './style/datatables.bundle.css';
import './style/plugins.bundle.rtl.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Comment from './pages/comment/Comment';
import App from "./pages/Home";
import CrossApp from './pages/cross/Cross';
import MarketPage from './pages/market/MarketPage';
import MarketPageUser from './pages/market/MarketPageUser';
import MarketSinglePage from './pages/market/MarketSinglePage';
import MarketRealTimePage from './pages/market/MarketRealTimePage';
import MarketRealTimeSinglePage from './pages/market/MarketRealTimeSinglePage';
import JustifyPage from './pages/justify/JustifyPage';
import StrategyListPage from './pages/StrategyListPage';
import FiltersPage from './pages/filters/FiltersPage';
import CalculatorsPage from './pages/calculators/CalculatorsPage';

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement);
if (rootElement.parentElement.id === 'development') {
    const props = rootElement.parentElement.getAttribute('data-props')
    const route = createBrowserRouter([
        {
            path: "/",
            element: <App />,
            errorElement: <h1 style={{ textAlign: "center" }}>داداش اشتباه اومدی</h1>
        },
        {
            path: "/cross",
            element: <CrossApp />
        },
        {
            path: "/market",
            element: <MarketPage />
        },
        {
            path: "/market/users",
            element: <MarketPageUser />
        },
        {
            path: "/market/symbol_list",
            element: <MarketSinglePage />
        },
        {
            path: "/market/realtime",
            element: <MarketRealTimePage />
        },
        {
            path: "/market/realtime/symbol_list",
            element: <MarketRealTimeSinglePage />
        },
        {
            path: '/justify',
            element: <JustifyPage />
        },
        {
            path: '/comment',
            element: <Comment {...JSON.parse(props)} />
        },
        {
            path: '/strategy',
            element: <StrategyListPage />
        },
        {
            path: '/filters',
            element: <FiltersPage />
        },
        {
            path: '/calculators',
            element: <CalculatorsPage />
        }
    ])

    root.render(
        <React.StrictMode>
            <RouterProvider router={route} />
        </React.StrictMode>
    )
} else {
    const page = rootElement.parentElement.id
    const props = rootElement.parentElement.getAttribute('data-props')
    let app
    switch (page) {
        case 'ct_cross':
            app = <CrossApp />
            break;
        case 'comment':
            app = <Comment {...JSON.parse(props)} />
            break;
        case 'index':
            app = <MarketPage />
            break;
        case 'users':
            app = <MarketPageUser page='users' />
            break
        case 'symbol_list':
            app = <MarketSinglePage />
            break;
        case 'realtime':
            app = <MarketRealTimePage />
            break;
        case 'realtime_symbol_list':
            app = <MarketRealTimeSinglePage />
            break;
        case 'justify':
            app = <JustifyPage />
            break;
        case 'strategy':
            app = <StrategyListPage />
            break;
        case 'filters':
            app = <FiltersPage />
            break;
        case 'calculators':
            app = <CalculatorsPage />
            break;
        default:
            console.log('It\'s some other day.');
    }
    root.render(
        <React.StrictMode>
            {app}
        </React.StrictMode>
    );
}